import { motion } from 'framer-motion';
import { FaTwitter, FaLinkedin, FaInstagram, FaYoutube, FaRegEnvelope } from 'react-icons/fa';
import { IoGlobeOutline } from 'react-icons/io5';

const Footer = () => {
  const footerLinks = [
    {
      title: 'Company',
      links: ['About Us', 'Careers', 'Blog', 'Press', 'Partners'],
    },
    {
      title: 'Invest',
      links: ['Crypto Assets', 'Precious Metals', 'Real Estate', 'Stocks', 'Commodities'],
    },
    {
      title: 'Legal',
      links: ['Privacy Policy', 'Terms of Service', 'Disclaimer', 'Regulations', 'Security'],
    },
  ];

  return (
    <footer className="bg-blue-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="space-y-4"
          >
            <img 
              src="logox-removebg-preview.png"  alt="" className='w-[200px]'/>
        
        
            <p className="text-blue-200 text-sm leading-relaxed">
              Since 2016, we have been dedicated to empowering global investors by providing innovative financial solutions tailored to meet their diverse needs. Our commitment extends to securing and managing assets with the highest standards of safety and reliability, ensuring our clients' investments are protected and optimized for growth.

            </p>
            <div className="flex space-x-4 mt-4">
              {[FaTwitter, FaLinkedin, FaInstagram, FaYoutube].map((Icon, index) => (
                <motion.a
                  key={index}
                  whileHover={{ scale: 1.1 }}
                  className="text-blue-300 hover:text-white transition-colors"
                  href="#"
                >
                  <Icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
            Email: info@portpayinvestment.com

          </motion.div>
   
          {/* Footer Links */}
          {footerLinks.map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="space-y-4"
            >
              <h4 className="text-white font-semibold text-lg mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-blue-200 hover:text-white text-sm transition-colors flex items-center group"
                    >
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}

          {/* Newsletter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="space-y-4"
          >
            <h4 className="text-white font-semibold text-lg mb-4">Stay Updated</h4>
            <div className="relative">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full p-3 rounded-lg bg-blue-800/30 border border-blue-700 focus:outline-none focus:border-blue-400 placeholder-blue-400 text-sm pr-12"
              />
              <button className="absolute right-2 top-2 bg-blue-500 hover:bg-blue-600 p-2 rounded-lg transition-colors">
                <FaRegEnvelope className="w-5 h-5" />
              </button>
            </div>
            <div className="flex items-center space-x-2 text-blue-300 text-sm mt-6">
              <IoGlobeOutline className="w-5 h-5" />
              <span>English</span>
            </div>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-blue-800 my-8"></div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          className="flex flex-col md:flex-row justify-between items-center text-blue-300 text-sm"
        >
          <div className="text-center md:text-left mb-4 md:mb-0">
            © {new Date().getFullYear()} Portpay Investment | All rights reserved.
          </div>
          <div className="flex space-x-4">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">Cookie Settings</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;